import { default as indexvsItmFSHtKMeta } from "/usr/src/nuxt-app/pages/[financier]/[publicId]/index.vue?macro=true";
import { default as reviewB2Gdl6A9pIMeta } from "/usr/src/nuxt-app/pages/[financier]/[publicId]/review.vue?macro=true";
import { default as customer_45limit_45email_45confirmO81hcwVJIeMeta } from "/usr/src/nuxt-app/pages/[financier]/customer-limit-email-confirm.vue?macro=true";
import { default as customer_45limit_45email_45confirmedHQSqoYx7MGMeta } from "/usr/src/nuxt-app/pages/[financier]/customer-limit-email-confirmed.vue?macro=true";
import { default as draftWCvKWpFxPZMeta } from "/usr/src/nuxt-app/pages/[financier]/customer-limit/draft.vue?macro=true";
import { default as indexfK6rJn2DgoMeta } from "/usr/src/nuxt-app/pages/[financier]/customer-limit/index.vue?macro=true";
import { default as resultzptP0ozGGfMeta } from "/usr/src/nuxt-app/pages/[financier]/customer-limit/result.vue?macro=true";
import { default as email_45confirmTFKmojeWuXMeta } from "/usr/src/nuxt-app/pages/[financier]/email-confirm.vue?macro=true";
import { default as email_45confirmednUOP1VCwjJMeta } from "/usr/src/nuxt-app/pages/[financier]/email-confirmed.vue?macro=true";
import { default as index6K4KsfIj4SMeta } from "/usr/src/nuxt-app/pages/[financier]/index.vue?macro=true";
import { default as index8XwAvEDjWYMeta } from "/usr/src/nuxt-app/pages/[financier]/limit/index.vue?macro=true";
import { default as _91prescoreId_93D0FvzTbApLMeta } from "/usr/src/nuxt-app/pages/[financier]/prescore/[prescoreId].vue?macro=true";
import { default as indexp7ojqssXrJMeta } from "/usr/src/nuxt-app/pages/[financier]/prescore/index.vue?macro=true";
import { default as _91publicId_93dsQqULd5qTMeta } from "/usr/src/nuxt-app/pages/b2b/[financier]/[publicId].vue?macro=true";
import { default as email_45confirmt5h3esQXQRMeta } from "/usr/src/nuxt-app/pages/b2b/[financier]/email-confirm.vue?macro=true";
import { default as email_45confirmedMZvpAVY52JMeta } from "/usr/src/nuxt-app/pages/b2b/[financier]/email-confirmed.vue?macro=true";
import { default as indexHu7zq1l63dMeta } from "/usr/src/nuxt-app/pages/b2b/[financier]/index.vue?macro=true";
import { default as _91companyId_93vW5IuNP5OMMeta } from "/usr/src/nuxt-app/pages/b2b/[financier]/limit/[companyId].vue?macro=true";
import { default as indexZ3LFcuHdbsMeta } from "/usr/src/nuxt-app/pages/b2b/[financier]/limit/index.vue?macro=true";
import { default as _91prescoreId_93laJVUzE2FKMeta } from "/usr/src/nuxt-app/pages/b2b/[financier]/prescore/[prescoreId].vue?macro=true";
import { default as indexWhuYfPuZupMeta } from "/usr/src/nuxt-app/pages/b2b/[financier]/prescore/index.vue?macro=true";
import { default as testlj6N7N7J6cMeta } from "/usr/src/nuxt-app/pages/b2b/[financier]/test.vue?macro=true";
import { default as indexOIocjZjuZjMeta } from "/usr/src/nuxt-app/pages/b2b/index.vue?macro=true";
import { default as indexAoBMx6PnC1Meta } from "/usr/src/nuxt-app/pages/index.vue?macro=true";
import { default as indexZSrwjFE2YlMeta } from "/usr/src/nuxt-app/pages/kyc/[financier]/[publicId]/index.vue?macro=true";
import { default as loginAgIJSi810lMeta } from "/usr/src/nuxt-app/pages/kyc/[financier]/[publicId]/login.vue?macro=true";
import { default as indexXXpRWY3lyrMeta } from "/usr/src/nuxt-app/pages/kyc/[financier]/index.vue?macro=true";
import { default as testbCKSAe7LChMeta } from "/usr/src/nuxt-app/pages/kyc/[financier]/test.vue?macro=true";
import { default as index206gfxH0YwMeta } from "/usr/src/nuxt-app/pages/kyc/index.vue?macro=true";
import { default as _91campaignId_93ABP0sgd3ZFMeta } from "/usr/src/nuxt-app/pages/referral/[campaignId].vue?macro=true";
import { default as indexhQJgsRAftHMeta } from "/usr/src/nuxt-app/pages/referral/index.vue?macro=true";
import { default as _91campaignId_93BLwxkPspeBMeta } from "/usr/src/nuxt-app/pages/referrer/[campaignId].vue?macro=true";
export default [
  {
    name: indexvsItmFSHtKMeta?.name ?? "financier-publicId",
    path: indexvsItmFSHtKMeta?.path ?? "/:financier/:publicId",
    children: [],
    meta: indexvsItmFSHtKMeta || {},
    alias: indexvsItmFSHtKMeta?.alias || [],
    redirect: indexvsItmFSHtKMeta?.redirect || undefined,
    component: () => import("/usr/src/nuxt-app/pages/[financier]/[publicId]/index.vue").then(m => m.default || m)
  },
  {
    name: reviewB2Gdl6A9pIMeta?.name ?? "financier-publicId-review",
    path: reviewB2Gdl6A9pIMeta?.path ?? "/:financier/:publicId/review",
    children: [],
    meta: reviewB2Gdl6A9pIMeta || {},
    alias: reviewB2Gdl6A9pIMeta?.alias || [],
    redirect: reviewB2Gdl6A9pIMeta?.redirect || undefined,
    component: () => import("/usr/src/nuxt-app/pages/[financier]/[publicId]/review.vue").then(m => m.default || m)
  },
  {
    name: customer_45limit_45email_45confirmO81hcwVJIeMeta?.name ?? "financier-customer-limit-email-confirm",
    path: customer_45limit_45email_45confirmO81hcwVJIeMeta?.path ?? "/:financier/customer-limit-email-confirm",
    children: [],
    meta: customer_45limit_45email_45confirmO81hcwVJIeMeta || {},
    alias: customer_45limit_45email_45confirmO81hcwVJIeMeta?.alias || [],
    redirect: customer_45limit_45email_45confirmO81hcwVJIeMeta?.redirect || undefined,
    component: () => import("/usr/src/nuxt-app/pages/[financier]/customer-limit-email-confirm.vue").then(m => m.default || m)
  },
  {
    name: customer_45limit_45email_45confirmedHQSqoYx7MGMeta?.name ?? "financier-customer-limit-email-confirmed",
    path: customer_45limit_45email_45confirmedHQSqoYx7MGMeta?.path ?? "/:financier/customer-limit-email-confirmed",
    children: [],
    meta: customer_45limit_45email_45confirmedHQSqoYx7MGMeta || {},
    alias: customer_45limit_45email_45confirmedHQSqoYx7MGMeta?.alias || [],
    redirect: customer_45limit_45email_45confirmedHQSqoYx7MGMeta?.redirect || undefined,
    component: () => import("/usr/src/nuxt-app/pages/[financier]/customer-limit-email-confirmed.vue").then(m => m.default || m)
  },
  {
    name: draftWCvKWpFxPZMeta?.name ?? "financier-customer-limit-draft",
    path: draftWCvKWpFxPZMeta?.path ?? "/:financier/customer-limit/draft",
    children: [],
    meta: draftWCvKWpFxPZMeta || {},
    alias: draftWCvKWpFxPZMeta?.alias || [],
    redirect: draftWCvKWpFxPZMeta?.redirect || undefined,
    component: () => import("/usr/src/nuxt-app/pages/[financier]/customer-limit/draft.vue").then(m => m.default || m)
  },
  {
    name: indexfK6rJn2DgoMeta?.name ?? "financier-customer-limit",
    path: indexfK6rJn2DgoMeta?.path ?? "/:financier/customer-limit",
    children: [],
    meta: indexfK6rJn2DgoMeta || {},
    alias: indexfK6rJn2DgoMeta?.alias || [],
    redirect: indexfK6rJn2DgoMeta?.redirect || undefined,
    component: () => import("/usr/src/nuxt-app/pages/[financier]/customer-limit/index.vue").then(m => m.default || m)
  },
  {
    name: resultzptP0ozGGfMeta?.name ?? "financier-customer-limit-result",
    path: resultzptP0ozGGfMeta?.path ?? "/:financier/customer-limit/result",
    children: [],
    meta: resultzptP0ozGGfMeta || {},
    alias: resultzptP0ozGGfMeta?.alias || [],
    redirect: resultzptP0ozGGfMeta?.redirect || undefined,
    component: () => import("/usr/src/nuxt-app/pages/[financier]/customer-limit/result.vue").then(m => m.default || m)
  },
  {
    name: email_45confirmTFKmojeWuXMeta?.name ?? "financier-email-confirm",
    path: email_45confirmTFKmojeWuXMeta?.path ?? "/:financier/email-confirm",
    children: [],
    meta: email_45confirmTFKmojeWuXMeta || {},
    alias: email_45confirmTFKmojeWuXMeta?.alias || [],
    redirect: email_45confirmTFKmojeWuXMeta?.redirect || undefined,
    component: () => import("/usr/src/nuxt-app/pages/[financier]/email-confirm.vue").then(m => m.default || m)
  },
  {
    name: email_45confirmednUOP1VCwjJMeta?.name ?? "financier-email-confirmed",
    path: email_45confirmednUOP1VCwjJMeta?.path ?? "/:financier/email-confirmed",
    children: [],
    meta: email_45confirmednUOP1VCwjJMeta || {},
    alias: email_45confirmednUOP1VCwjJMeta?.alias || [],
    redirect: email_45confirmednUOP1VCwjJMeta?.redirect || undefined,
    component: () => import("/usr/src/nuxt-app/pages/[financier]/email-confirmed.vue").then(m => m.default || m)
  },
  {
    name: index6K4KsfIj4SMeta?.name ?? "financier",
    path: index6K4KsfIj4SMeta?.path ?? "/:financier",
    children: [],
    meta: index6K4KsfIj4SMeta || {},
    alias: index6K4KsfIj4SMeta?.alias || [],
    redirect: index6K4KsfIj4SMeta?.redirect || undefined,
    component: () => import("/usr/src/nuxt-app/pages/[financier]/index.vue").then(m => m.default || m)
  },
  {
    name: index8XwAvEDjWYMeta?.name ?? "financier-limit",
    path: index8XwAvEDjWYMeta?.path ?? "/:financier/limit",
    children: [],
    meta: index8XwAvEDjWYMeta || {},
    alias: index8XwAvEDjWYMeta?.alias || [],
    redirect: index8XwAvEDjWYMeta?.redirect || undefined,
    component: () => import("/usr/src/nuxt-app/pages/[financier]/limit/index.vue").then(m => m.default || m)
  },
  {
    name: _91prescoreId_93D0FvzTbApLMeta?.name ?? "financier-prescore-prescoreId",
    path: _91prescoreId_93D0FvzTbApLMeta?.path ?? "/:financier/prescore/:prescoreId",
    children: [],
    meta: _91prescoreId_93D0FvzTbApLMeta || {},
    alias: _91prescoreId_93D0FvzTbApLMeta?.alias || [],
    redirect: _91prescoreId_93D0FvzTbApLMeta?.redirect || undefined,
    component: () => import("/usr/src/nuxt-app/pages/[financier]/prescore/[prescoreId].vue").then(m => m.default || m)
  },
  {
    name: indexp7ojqssXrJMeta?.name ?? "financier-prescore",
    path: indexp7ojqssXrJMeta?.path ?? "/:financier/prescore",
    children: [],
    meta: indexp7ojqssXrJMeta || {},
    alias: indexp7ojqssXrJMeta?.alias || [],
    redirect: indexp7ojqssXrJMeta?.redirect || undefined,
    component: () => import("/usr/src/nuxt-app/pages/[financier]/prescore/index.vue").then(m => m.default || m)
  },
  {
    name: _91publicId_93dsQqULd5qTMeta?.name ?? "b2b-financier-publicId",
    path: _91publicId_93dsQqULd5qTMeta?.path ?? "/b2b/:financier/:publicId",
    children: [],
    meta: _91publicId_93dsQqULd5qTMeta || {},
    alias: _91publicId_93dsQqULd5qTMeta?.alias || [],
    redirect: _91publicId_93dsQqULd5qTMeta?.redirect || undefined,
    component: () => import("/usr/src/nuxt-app/pages/b2b/[financier]/[publicId].vue").then(m => m.default || m)
  },
  {
    name: email_45confirmt5h3esQXQRMeta?.name ?? "b2b-financier-email-confirm",
    path: email_45confirmt5h3esQXQRMeta?.path ?? "/b2b/:financier/email-confirm",
    children: [],
    meta: email_45confirmt5h3esQXQRMeta || {},
    alias: email_45confirmt5h3esQXQRMeta?.alias || [],
    redirect: email_45confirmt5h3esQXQRMeta?.redirect || undefined,
    component: () => import("/usr/src/nuxt-app/pages/b2b/[financier]/email-confirm.vue").then(m => m.default || m)
  },
  {
    name: email_45confirmedMZvpAVY52JMeta?.name ?? "b2b-financier-email-confirmed",
    path: email_45confirmedMZvpAVY52JMeta?.path ?? "/b2b/:financier/email-confirmed",
    children: [],
    meta: email_45confirmedMZvpAVY52JMeta || {},
    alias: email_45confirmedMZvpAVY52JMeta?.alias || [],
    redirect: email_45confirmedMZvpAVY52JMeta?.redirect || undefined,
    component: () => import("/usr/src/nuxt-app/pages/b2b/[financier]/email-confirmed.vue").then(m => m.default || m)
  },
  {
    name: indexHu7zq1l63dMeta?.name ?? "b2b-financier",
    path: indexHu7zq1l63dMeta?.path ?? "/b2b/:financier",
    children: [],
    meta: indexHu7zq1l63dMeta || {},
    alias: indexHu7zq1l63dMeta?.alias || [],
    redirect: indexHu7zq1l63dMeta?.redirect || undefined,
    component: () => import("/usr/src/nuxt-app/pages/b2b/[financier]/index.vue").then(m => m.default || m)
  },
  {
    name: _91companyId_93vW5IuNP5OMMeta?.name ?? "b2b-financier-limit-companyId",
    path: _91companyId_93vW5IuNP5OMMeta?.path ?? "/b2b/:financier/limit/:companyId",
    children: [],
    meta: _91companyId_93vW5IuNP5OMMeta || {},
    alias: _91companyId_93vW5IuNP5OMMeta?.alias || [],
    redirect: _91companyId_93vW5IuNP5OMMeta?.redirect || undefined,
    component: () => import("/usr/src/nuxt-app/pages/b2b/[financier]/limit/[companyId].vue").then(m => m.default || m)
  },
  {
    name: indexZ3LFcuHdbsMeta?.name ?? "b2b-financier-limit",
    path: indexZ3LFcuHdbsMeta?.path ?? "/b2b/:financier/limit",
    children: [],
    meta: indexZ3LFcuHdbsMeta || {},
    alias: indexZ3LFcuHdbsMeta?.alias || [],
    redirect: indexZ3LFcuHdbsMeta?.redirect || undefined,
    component: () => import("/usr/src/nuxt-app/pages/b2b/[financier]/limit/index.vue").then(m => m.default || m)
  },
  {
    name: _91prescoreId_93laJVUzE2FKMeta?.name ?? "b2b-financier-prescore-prescoreId",
    path: _91prescoreId_93laJVUzE2FKMeta?.path ?? "/b2b/:financier/prescore/:prescoreId",
    children: [],
    meta: _91prescoreId_93laJVUzE2FKMeta || {},
    alias: _91prescoreId_93laJVUzE2FKMeta?.alias || [],
    redirect: _91prescoreId_93laJVUzE2FKMeta?.redirect || undefined,
    component: () => import("/usr/src/nuxt-app/pages/b2b/[financier]/prescore/[prescoreId].vue").then(m => m.default || m)
  },
  {
    name: indexWhuYfPuZupMeta?.name ?? "b2b-financier-prescore",
    path: indexWhuYfPuZupMeta?.path ?? "/b2b/:financier/prescore",
    children: [],
    meta: indexWhuYfPuZupMeta || {},
    alias: indexWhuYfPuZupMeta?.alias || [],
    redirect: indexWhuYfPuZupMeta?.redirect || undefined,
    component: () => import("/usr/src/nuxt-app/pages/b2b/[financier]/prescore/index.vue").then(m => m.default || m)
  },
  {
    name: testlj6N7N7J6cMeta?.name ?? "b2b-financier-test",
    path: testlj6N7N7J6cMeta?.path ?? "/b2b/:financier/test",
    children: [],
    meta: testlj6N7N7J6cMeta || {},
    alias: testlj6N7N7J6cMeta?.alias || [],
    redirect: testlj6N7N7J6cMeta?.redirect || undefined,
    component: () => import("/usr/src/nuxt-app/pages/b2b/[financier]/test.vue").then(m => m.default || m)
  },
  {
    name: indexOIocjZjuZjMeta?.name ?? "b2b",
    path: indexOIocjZjuZjMeta?.path ?? "/b2b",
    children: [],
    meta: indexOIocjZjuZjMeta || {},
    alias: indexOIocjZjuZjMeta?.alias || [],
    redirect: indexOIocjZjuZjMeta?.redirect || undefined,
    component: () => import("/usr/src/nuxt-app/pages/b2b/index.vue").then(m => m.default || m)
  },
  {
    name: indexAoBMx6PnC1Meta?.name ?? "index",
    path: indexAoBMx6PnC1Meta?.path ?? "/",
    children: [],
    meta: indexAoBMx6PnC1Meta || {},
    alias: indexAoBMx6PnC1Meta?.alias || [],
    redirect: indexAoBMx6PnC1Meta?.redirect || undefined,
    component: () => import("/usr/src/nuxt-app/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexZSrwjFE2YlMeta?.name ?? "kyc-financier-publicId",
    path: indexZSrwjFE2YlMeta?.path ?? "/kyc/:financier/:publicId",
    children: [],
    meta: indexZSrwjFE2YlMeta || {},
    alias: indexZSrwjFE2YlMeta?.alias || [],
    redirect: indexZSrwjFE2YlMeta?.redirect || undefined,
    component: () => import("/usr/src/nuxt-app/pages/kyc/[financier]/[publicId]/index.vue").then(m => m.default || m)
  },
  {
    name: loginAgIJSi810lMeta?.name ?? "kyc-financier-publicId-login",
    path: loginAgIJSi810lMeta?.path ?? "/kyc/:financier/:publicId/login",
    children: [],
    meta: loginAgIJSi810lMeta || {},
    alias: loginAgIJSi810lMeta?.alias || [],
    redirect: loginAgIJSi810lMeta?.redirect || undefined,
    component: () => import("/usr/src/nuxt-app/pages/kyc/[financier]/[publicId]/login.vue").then(m => m.default || m)
  },
  {
    name: indexXXpRWY3lyrMeta?.name ?? "kyc-financier",
    path: indexXXpRWY3lyrMeta?.path ?? "/kyc/:financier",
    children: [],
    meta: indexXXpRWY3lyrMeta || {},
    alias: indexXXpRWY3lyrMeta?.alias || [],
    redirect: indexXXpRWY3lyrMeta?.redirect || undefined,
    component: () => import("/usr/src/nuxt-app/pages/kyc/[financier]/index.vue").then(m => m.default || m)
  },
  {
    name: testbCKSAe7LChMeta?.name ?? "kyc-financier-test",
    path: testbCKSAe7LChMeta?.path ?? "/kyc/:financier/test",
    children: [],
    meta: testbCKSAe7LChMeta || {},
    alias: testbCKSAe7LChMeta?.alias || [],
    redirect: testbCKSAe7LChMeta?.redirect || undefined,
    component: () => import("/usr/src/nuxt-app/pages/kyc/[financier]/test.vue").then(m => m.default || m)
  },
  {
    name: index206gfxH0YwMeta?.name ?? "kyc",
    path: index206gfxH0YwMeta?.path ?? "/kyc",
    children: [],
    meta: index206gfxH0YwMeta || {},
    alias: index206gfxH0YwMeta?.alias || [],
    redirect: index206gfxH0YwMeta?.redirect || undefined,
    component: () => import("/usr/src/nuxt-app/pages/kyc/index.vue").then(m => m.default || m)
  },
  {
    name: _91campaignId_93ABP0sgd3ZFMeta?.name ?? "referral-campaignId",
    path: _91campaignId_93ABP0sgd3ZFMeta?.path ?? "/referral/:campaignId",
    children: [],
    meta: _91campaignId_93ABP0sgd3ZFMeta || {},
    alias: _91campaignId_93ABP0sgd3ZFMeta?.alias || [],
    redirect: _91campaignId_93ABP0sgd3ZFMeta?.redirect || undefined,
    component: () => import("/usr/src/nuxt-app/pages/referral/[campaignId].vue").then(m => m.default || m)
  },
  {
    name: indexhQJgsRAftHMeta?.name ?? "referral",
    path: indexhQJgsRAftHMeta?.path ?? "/referral",
    children: [],
    meta: indexhQJgsRAftHMeta || {},
    alias: indexhQJgsRAftHMeta?.alias || [],
    redirect: indexhQJgsRAftHMeta?.redirect || undefined,
    component: () => import("/usr/src/nuxt-app/pages/referral/index.vue").then(m => m.default || m)
  },
  {
    name: _91campaignId_93BLwxkPspeBMeta?.name ?? "referrer-campaignId",
    path: _91campaignId_93BLwxkPspeBMeta?.path ?? "/referrer/:campaignId",
    children: [],
    meta: _91campaignId_93BLwxkPspeBMeta || {},
    alias: _91campaignId_93BLwxkPspeBMeta?.alias || [],
    redirect: _91campaignId_93BLwxkPspeBMeta?.redirect || undefined,
    component: () => import("/usr/src/nuxt-app/pages/referrer/[campaignId].vue").then(m => m.default || m)
  }
]